import React, { useState, useContext } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';
import { useForm, Resolver, Controller } from "react-hook-form"
import API from '../API'
import { DayAllocated, UserDeleteEntryType, UserUpdateEntryType, UserUpdateRowType } from '../interfaces';
import { getDayOfWeekName, lookupNameFromObjectsArray } from '../global'
import { SaveDayResponse, ReportingData, ReportingDataDay, DeleteDayResponse, QueryTimeReportRows, AdminPersonMonthReport, InitData, QueryActivities } from '../../../backend/src/api/dto';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';

type FormValues = {
    hours: string
    activityId: string
    startDate: string
    endDate: string
    overwrite: boolean
}




function UserAddMultipleDayEntries({ item, activity, initData, currentData, dayAllocated, updateRow }: {
    item: QueryTimeReportRows,
    activity: QueryActivities,
    initData: InitData,
    currentData: ReportingData,
    dayAllocated: DayAllocated,
    updateRow: UserUpdateRowType,
}) {


    const [showModal, closeModal] = useContext(ModalContext);
    const { register, control, handleSubmit, getValues } = useForm<FormValues>({
        defaultValues: {
            activityId: (activity.activityId ? String(activity.activityId) : "0"),
            overwrite: true
        }
    })

    const [loading, setLoading] = useState(false);
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)

    const modalButtons = [
        {
            text: 'Confirm',
            icon: 'check',
            onClick: () => onSubmit(),

            style: 'primary'
        }, {
            text: 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    const onSubmit = () => {
        const form = getValues();


        setLoading(true);
        return new Promise((resolve, reject) => {
            handleSubmit((data) => {
                console.log({ data: getValues() })

                const hoursValue = parseInt(data.hours);
                const activityIdValue = parseInt(data.activityId, 10);

                if (Number.isInteger(hoursValue)) {
                    API.userSetDateRange(item.timeReportRowId, dayjs(data.startDate).format("YYYY-MM-DD"), dayjs(data.endDate).format("YYYY-MM-DD"), hoursValue, activityIdValue, data.overwrite).then((data2: SaveDayResponse[]) => {
                        setLoading(false);
                        setApiResult({
                            status: true,
                        })
                        updateRow(data2)
                        closeModal(null);
                        resolve(1)
                    }).catch((e) => {
                        console.log("--- 1", e)
                        setLoading(false);
                        setApiResult(e)
                        resolve(1)
                    })
                }
            })()
        })

    }



    return (



        <Modal
            buttons={modalButtons}
            title={'Upraviť riadok'}
            errorObject={apiResult}
            disableAllButtons={loading}
        >
            <form onSubmit={onSubmit} style={{ minHeight: '350px' }}>


                <div className="row">
                    <div className="col-4 mt-1 text-end">
                        <label className="form-label">Od</label>
                    </div>
                    <div className="col-auto">
                        <Controller
                            control={control}
                            name='startDate'
                            render={({ field }) => (
                                <DatePicker
                                    onChange={(date) => field.onChange(date)}
                                    selected={field.value ? new Date(field.value) : null}
                                    dateFormat='YYYY-MM-dd'
                                    minDate={new Date(currentData.year, (currentData.month - 1), 1)}
                                    maxDate={new Date(currentData.year, (currentData.month - 1), currentData.daysInMonth)}
                                    calendarStartDay={1}
                                />
                            )}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4 mt-1 text-end">
                        <label className="form-label">Do</label>
                    </div>
                    <div className="col-auto">
                        <Controller
                            control={control}
                            name='endDate'
                            render={({ field }) => (
                                <DatePicker
                                    onChange={(date) => field.onChange(date)}
                                    selected={field.value ? new Date(field.value) : null}
                                    dateFormat='YYYY-MM-dd'
                                    minDate={new Date(currentData.year, (currentData.month - 1), 1)}
                                    maxDate={new Date(currentData.year, (currentData.month - 1), currentData.daysInMonth)}
                                    calendarStartDay={1}
                                />
                            )}

                        />
                    </div>
                </div>



                <div className="row mb-2">
                    <div className="col-4 text-end mt-1">
                        Hodiny
                    </div>
                    <div className="col-3">
                        <div className="input-group">
                            <input autoFocus {...register("hours")} className="form-control form-control-sm" />
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="offset-4 col-8">
                        <div className="form-check">
                            <input className="form-check-input" {...register("overwrite")} type="checkbox" />
                            <label className="form-check-label">
                                Prepísať už zadané
                            </label>
                        </div>
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-4 text-end">
                        Projekt
                    </div>
                    <div className="col-7">
                        {item.projectName}
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-4 text-end">
                        Komponent
                    </div>
                    <div className="col-7">
                        {item.orderName}
                    </div>
                </div>



                {
                    item.withActivities ?

                        <div className="row mb-2">
                            <div className="col-4 text-end mt-1">
                                Aktivita
                            </div>
                            <div className="col-8">{
                                <select className="form-select form-select-sm" {...register("activityId")} >
                                    {
                                        initData.activities.map(act => {
                                            return (
                                                <option value={act.activityId}>{act.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            }</div>
                        </div>
                        :
                        null
                }

            </form>
        </Modal>


    )

}

export default UserAddMultipleDayEntries
